import graphql from "babel-plugin-relay/macro";

const SendTicketToWattsappQuery = graphql`
  query SendTicketToWattsappQuery($bookingId: String!) {
    sendTicketToWa(bookingId: $bookingId) {
      message
      status
    }
  }
`;

export default SendTicketToWattsappQuery;
